module.exports = __webpack_public_path__ + "static/newborn-header-672267cd241f2340229cdee7ae80cfdf.jpg";